import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { UgcImageGalleryComponent } from '../ugc-image-gallery.component';
import { NUgcImageGallery } from '../ugc-image-gallery.namespace';
@Component({
    selector: 'ugc-image-gallery-cms',
    template: '<ugc-image-gallery [content]="component" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UgcImageGalleryComponent]
})
@ICmsComponent<UgcImageGalleryCmsComponent>({
    id: 'ugc-image-gallery',
    name: 'User Generated Content Image Gallery Layout',
    tags: ['ugc', 'gallery'],
    fields: [...NUgcImageGallery.FIELDS, NUgcImageGallery.UGC_CATEGORY_FIELD, NUgcImageGallery.UGC_RANGE_CODE_NH_FIELD]
})
export class UgcImageGalleryCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NUgcImageGallery.IData;
}
